import { ReactNode } from 'react';
import { useZgriDashboardViewPermission } from '@/hooks/usePermission';

type ZgriVisibilityGuardProps = {
  children: ReactNode;
  /** The fallback component to render if the ZGRI dashboard or ops features are not enabled */
  fallback?: ReactNode;
};

/**
 * A guard component that conditionally renders its children based on the visibility of the ZGRI dashboard or ops features.
 * If the ZGRI dashboard or ops features are enabled, it renders the children. Otherwise, it renders the fallback component, by default `null`.
 */
export function ZgriVisibilityGuard({ children, fallback = null }: ZgriVisibilityGuardProps) {
  const { enabled: zgriDashboardViewEnabled } = useZgriDashboardViewPermission();

  if (zgriDashboardViewEnabled) {
    return <>{children}</>;
  }

  return fallback;
}
